import React from 'react';
import CardContainer from '../card-container';
import Content from './content';

const CardBack = ({ card, readonly, onClick = () => {} }) => {
  return (
    <CardContainer
      onClick={(e) => onClick()}
      initial={{ rotateY: -90, opacity: 1 }}
      animate={{ rotateY: 0 }}
      exit={{ rotateY: 90, opacity: 0 }}
      className="relative"
      style={{ userSelect: 'none' }}
    >
      <Content card={card} readonly={readonly} />
    </CardContainer>
  );
};

export default CardBack;
